import styled from "styled-components"

import { Text } from "@minuthq/meatball-ui-react"

import { TGuestExtended } from "src/data/guests/types/guestTypes"
import { langKeys } from "src/i18n/langKeys"
import { useTranslate } from "src/i18n/useTranslate"

export function GuestSource({
  extendedGuest,
}: {
  extendedGuest: TGuestExtended
}) {
  const { t } = useTranslate()

  const sourceName = extendedGuest.sourceName || extendedGuest.source

  if (!sourceName) {
    return null
  }

  return (
    <Wrapper>
      <Text variant="body">{t(langKeys.add_stay_dialog_imported_from)} </Text>
      <GuestSourceIcon sourceName={sourceName} logo={extendedGuest.logo} />
    </Wrapper>
  )
}

function GuestSourceIcon({
  sourceName,
  logo,
}: {
  sourceName: string
  logo?: string
}) {
  if (!logo) {
    return <Text as="span">{sourceName}</Text>
  }

  return (
    <img
      src={logo}
      alt="logo"
      style={{ height: "32px", margin: "0 0.25rem" }}
    />
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`
